(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["PageHero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
  var videoModal = document.getElementById("videoModal");
  var videoIframe = videoModal.querySelector("iframe");
  var videoSrc = "";

  // When clicking play button
  document.querySelectorAll(".btn-play-medium").forEach(function (btn) {
    btn.addEventListener("click", function () {
      videoSrc = this.getAttribute("data-src");
      console.log('Video SRC',videoSrc);
    });
  });

  // Set src only when modal is fully shown
  videoModal.addEventListener("shown.bs.modal", function () {
    videoIframe.setAttribute("src", videoSrc + "?autoplay=1");
  });

  // Remove src when modal is closed
  videoModal.addEventListener("hide.bs.modal", function () {
    videoIframe.setAttribute("src", "");
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["SpringfreeProductCarousel"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
    const lazySections = document.querySelectorAll('.js-lazy-section');

    const lazyLoadCallback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const section = entry.target;
                const images = section.querySelectorAll('.js-lazy-img');

                images.forEach(img => {
                    if (img.dataset.src) {
                        img.src = img.dataset.src;
                        img.removeAttribute('data-src'); // Clean up data-src
                    }
                });

                // If Glide.js needs to be initialized after images are loaded
                // you would do it here or trigger an event.
                // Example: initializeGlideCarousel(section.querySelector('.glide-product-carousel'));

                observer.unobserve(section); // Stop observing once loaded
            }
        });
    };

    const lazyLoadObserver = new IntersectionObserver(lazyLoadCallback, {
        rootMargin: '0px 0px 100px 0px', // Load 100px before it enters viewport
        threshold: 0 // As soon as any part of the section is visible
    });

    lazySections.forEach(section => {
        lazyLoadObserver.observe(section);
    });

    // If your Glide carousel needs to be initialized only after the images are loaded,
    // you might want to call its initialization function within the lazyLoadCallback.
    // For now, assume Glide is initialized on DOMContentLoaded as before,
    // but its images will only become visible when this script runs.

    // Example of Glide.js initialization (if it's not already in a separate file)
    // You might need to re-initialize or refresh Glide after images load if layouts shift.
    const glideElements = document.querySelectorAll('.glide-product-carousel');
    if (glideElements.length > 0) {
        glideElements.forEach(glideElement => {
            new Glide(glideElement, {
                // Your existing Glide configuration
                type: 'carousel',
                perView: 3, // Example
                gap: 30, // Example
                breakpoints: {
                    768: {
                        perView: 1
                    }
                }
            }).mount();
        });
    }
});
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["black-friday-hero"]) return;
  try {
    
  console.log("test")
  

  } catch(e) { console.error(e); }
})();
})();
